import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import uuid from 'node-uuid'
import { selectShouldRenderAds } from 'services/bootup/selectors'
import { selectShouldSeeAds } from 'services/premium/selectors'
import { selectAdUnitPath } from 'services/ads/selectors'
import { selectPathname } from 'services/routing/selectors'
import { targetWithCriteo } from './utils'

function mapStateToProps (state, props) {
  return {
    adUnitPath: props.customAdUnit || selectAdUnitPath(state),
    shouldSeeAds: selectShouldSeeAds(state),
    pathname: selectPathname(state),
    shouldRenderAds: selectShouldRenderAds(state),
  }
}

class Ad extends Component {

  static propTypes = {
    adUnitPath: PropTypes.string.isRequired,
    customAdUnit: PropTypes.string,
    pathname: PropTypes.string.isRequired,
    position: PropTypes.oneOf(['bottom', 'top']),
    shouldSeeAds: PropTypes.bool.isRequired,
    shouldRenderAds: PropTypes.bool.isRequired,
    sizes: PropTypes.arrayOf(PropTypes.array),
  }

  static defaultProps = {
    position: 'top',
  }

  componentWillMount () {
    // This will create ads for any components that are mounted during a react router transition
    // Otherwise, they will go through the respective update lifecycle methods below.
    const { pathname, adUnitPath, shouldSeeAds } = this.props

    if (pathname && adUnitPath && shouldSeeAds) {
      this.id = uuid.v4()
    }
  }

  componentDidMount () {
    const { pathname, adUnitPath, shouldSeeAds } = this.props
    if (pathname && adUnitPath && shouldSeeAds) {
      this.createSlot()
    }
  }

  shouldComponentUpdate (nextProps) {
    const { pathname, adUnitPath, shouldSeeAds } = this.props
    const shouldSeeAdsChanged = shouldSeeAds !== nextProps.shouldSeeAds
    const pathnameChanged = pathname !== nextProps.pathname
    const adUnitPathChanged = adUnitPath !== nextProps.adUnitPath
    return pathnameChanged || adUnitPathChanged || shouldSeeAdsChanged
  }

  componentWillUpdate () {
    this.id = uuid.v4()
    this.destroySlot()
  }

  componentDidUpdate () {
    this.createSlot()
  }

  componentWillUnmount () {
    this.destroySlot()
  }

  createSlot = () => {
    const { googletag } = window
    const { adUnitPath, position, sizes, shouldRenderAds } = this.props
    const { id } = this
    if (adUnitPath === '' || !shouldRenderAds) { return }
    googletag.cmd.push(() => {
      targetWithCriteo()
      this.slot = googletag.defineSlot(adUnitPath, sizes, id)
      this.slot.addService(googletag.pubads())
      this.slot.setTargeting('pos', position)
      googletag.enableServices()
      googletag.display(id)
    })
  }

  destroySlot = () => {
    if (this.slot) { window.googletag.destroySlots([this.slot]) }
  }

  render () {
    const { adUnitPath, shouldSeeAds, shouldRenderAds, sizes } = this.props
    const { id } = this
    if (!shouldRenderAds || !shouldSeeAds || !id || !adUnitPath) { return null }

    const maxHeight = sizes.reduce((min, [ , height ]) => { return Math.min(min, height) }, Number.POSITIVE_INFINITY)
    const maxWidth = sizes.reduce((min, [ width ]) => { return Math.min(min, width) }, Number.POSITIVE_INFINITY)

    const additionalStyles = {}
    if (process.env.NODE_ENV === 'development') { additionalStyles.background = '#eee' }

    return (
      <div style={{ maxHeight, maxWidth, margin: '.5em auto', ...additionalStyles }}>
        <div id={id} />
      </div>
    )
  }

}

export default connect(mapStateToProps)(Ad)



// WEBPACK FOOTER //
// ./src/components/util/ads/Ad.jsx